import React from 'react'
import { css } from 'glamor'
import { colours } from '../../constants/colourConstants'
import { propMerge } from 'glamor/react'
import { paragraphStyles } from '../../constants/textStyles'

const styles = {
	...paragraphStyles,
	color: colours.greys.blue,
}
const pStyles = css(styles)

const Paragraph = ({ children, ...otherProps }) => {
	return <p {...propMerge(pStyles, otherProps)}>{children}</p>
}

export default Paragraph